export default __webpack_public_path__ + "static/media/CNo.37-2.c387cfd9.jpg";